import { Injectable } from '@angular/core';

import DomainEventProvider from '../../../../../core/domain/events/domain_event_provider';
import { ScheduledTaskEvent } from './scheduled_task_events';

@Injectable({ providedIn: 'root' })
export class ScheduledTaskEventProvider extends DomainEventProvider<ScheduledTaskEvent> {}
